// extracted by mini-css-extract-plugin
module.exports = {"row":"SyllabusRow_row__rPiFS","striped":"SyllabusRow_striped__GAVSq","subtopicCell":"SyllabusRow_subtopicCell__Tzo6J","pointsCell":"SyllabusRow_pointsCell__MyQ0s"};